import React from 'react';

import { useTranslation } from 'react-i18next';
import { locales } from '../../../i18n';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';

import { 
  IInsurance, 
  InsuranceParameters, 
  SetInsuranceParameters,
  SetInsurance 
} from '../../../types';
import { dateConvert } from '../../../helpers/dateToIso';
import { iSoToDate } from '../../../helpers/fromIsoToDate';
import { 
  DateInputWrapper, 
  DateInputTitle, 
  DatesInput, 
  DatePickerWrapper, 
  DatePicker 
} from '../style';

let today = new Date();

type Props = {
  insurance: IInsurance;
  insuranceParameters?: InsuranceParameters;
  setInsuranceParameters?: SetInsuranceParameters;
  setInsurance: SetInsurance;
};

const DatesSelect: React.FC<Props> = ({
  insurance,
  insuranceParameters,
  setInsuranceParameters,
  setInsurance
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { selectedDates } = insuranceParameters; 

  const handleDate = (event: any, type: any) => {  
    if (type === 'from') {
      setInsuranceParameters({
        ...insuranceParameters,
        selectedDates: {
          ...selectedDates,
          startDate: event,
        },
      });
      setInsurance({
        ...insurance,
        details: {
          ...insurance.details,
          start_date: dateConvert(event)
        }
      });
    } else {
      setInsuranceParameters({
        ...insuranceParameters,
        selectedDates: {
          ...selectedDates,
          endDate: event,
        },
      });
      setInsurance({
        ...insurance,
        details: {
          ...insurance.details,
          end_date: dateConvert(event)
        }
      });
    }
  }; 

  const getMinDate = () => {
    let minDate = new Date(selectedDates.startDate);
    minDate.setDate(minDate.getDate() + 2);
    minDate.toLocaleDateString();
    return selectedDates.startDate ? minDate : today;
  };

  return (
    <DateInputWrapper>
      <DateInputTitle>{t('when_to_go')}</DateInputTitle>
      <DatesInput>
        <DatePickerWrapper
          dateAdapter={AdapterDateFns}
          adapterLocale={locales[language]}
        >
          <DatePicker
            label={t('date_from')}
            value={  
              iSoToDate(selectedDates?.startDate)         
              || iSoToDate(insurance.details?.start_date) || null
            }
            minDate={today}           
            disableMaskedInput
            onChange={(newValue) => {
              handleDate(newValue, 'from');
            }}
            renderInput={(params) => (
              <TextField 
                style={{ width: '50%' }} 
                {...params} 
                inputProps={{
                  ...params.inputProps,
                  placeholder: t('date_picker_place_holder')
                }}
              />
            )}
          />
        </DatePickerWrapper>
        <DatePickerWrapper
          dateAdapter={AdapterDateFns}
          adapterLocale={locales[language]}
        >
          <DatePicker
            label={t('date_to')}
            value={
              iSoToDate(selectedDates?.endDate)             
              || iSoToDate(insurance.details?.end_date) || null
            }
            minDate={getMinDate()}
            disableMaskedInput
            onChange={(newValue) => {
              handleDate(newValue, 'till');
            }}
            renderInput={(params) => (
              <TextField 
                style={{ width: '50%' }} 
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: t('date_picker_place_holder')
                }} 
              />
            )}
          />
        </DatePickerWrapper>
      </DatesInput>
    </DateInputWrapper>
  );
};

export default DatesSelect;
